// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"1a716f3b","460":"1a716f3b","789":"1a716f3b"}[chunkId] + ".chunk.css";
};